import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 10
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4
      }
    }
  };
  return <section className="py-24 px-4 bg-cream" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="bg-cream-alt rounded-3xl p-8 md:p-12 shadow-sm border border-brown/5" data-id="element-32">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-33">
            Después de aplicar estas enseñanzas podrás:
          </motion.h2>

          <motion.ul variants={itemVariants} className="space-y-6 mb-12" data-id="element-34">
            {['Reducir el sobrepensamiento', 'Sentir mayor calma mental', 'Tomar decisiones con claridad', 'Manejar mejor el estrés', 'Vivir con una mente más tranquila'].map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-35">
                <div className="bg-gold-start/20 p-2 rounded-full shrink-0" data-id="element-36">
                  <Check className="w-5 h-5 text-gold-end" data-id="element-37" />
                </div>
                <span className="text-xl text-brown font-medium" data-id="element-38">{item}</span>
              </li>)}
          </motion.ul>

          <motion.div variants={itemVariants} className="text-center pt-8 border-t border-brown/10" data-id="element-39">
            <p className="text-2xl font-playfair italic text-gold-end font-medium" data-id="element-40">
              Imagina cómo sería tu vida si tu mente dejara de luchar
              constantemente.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}